export const GLOBAL_TOASTS = {};
export const MAX_TOAST_IMAGES = 3;
